import { allTrackers } from "app/services/track/track";
import createAssignToUsersTrackingService from "./factory";

const assignToUsersTrackingService = createAssignToUsersTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default assignToUsersTrackingService;
